import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./ListingDetailBlock.css";
import ListingDetailBlockItem from "./ListingDetailBlockItem/ListingDetailBlockItem";
import { InfoIcon } from "../../constants/icons";
const ListingDetailBlock = ({ title, items, tooltip }) => {
  useEffect(() => {
    console.log("use items", items);
  }, [items]);

  return (
    <div className="table-details-block-box">
      <div className="table-details-block-box-title">
        <h3>
          {title}
          {tooltip ? (
            <span
              className={"title-info-tooltip"}
              style={{ position: "relative" }}
              data-tooltip-html={tooltip}
            >
              <InfoIcon />
            </span>
          ) : (
            ""
          )}
        </h3>
      </div>
      <div className="table-details-block-box-content">
        <div className="table-details-block-box-content-col2">
          {items?.map((item, i) => {
            return <ListingDetailBlockItem item={item} key={i} />;
          })}
        </div>
        <div className="table-details-block-box-content-col1 table-details-block-box-content-empty"></div>
      </div>
    </div>
  );
};

export default ListingDetailBlock;
